import React from "react";

import AccountLayout from "../../components/AccountLayout";
import AccountRoute from "../../components/AccountRoute";
import AppLayout from "../../components/AppLayout";
import Profile from "../../page-components/Profile";

function ProfilePage(props) {
  return (
    <AppLayout withFooter={false} pageTitle="Profile" shouldIndex={false}>
      <AccountLayout
        {...props}
        render={(props) => (
          <AccountRoute
            path="/account/profile"
            Component={Profile}
            {...props}
          />
        )}
      />
    </AppLayout>
  );
}

export default ProfilePage;
